(() => {
  const selector = '[data-cb-reveal]';

  const reveal = (root = document) => {
    const elements = Array.from(root.querySelectorAll(selector)).filter(
      (element) => !element.dataset.cbRevealBound
    );

    if (!elements.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      elements.forEach((element) => {
        element.dataset.cbRevealBound = 'true';
        element.classList.add('is-visible');
      });
      return;
    }

    const observer = new IntersectionObserver(
      (entries, instance) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          instance.unobserve(entry.target);
        });
      },
      {
        rootMargin: '0px 0px -12% 0px',
        threshold: 0.18,
      }
    );

    elements.forEach((element) => {
      element.dataset.cbRevealBound = 'true';
      observer.observe(element);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => reveal());
  } else {
    reveal();
  }

  document.addEventListener('shopify:section:load', (event) => reveal(event.target));
})();
